import { ProgramData } from '../components/ProgramLandingTemplate';

export const PROGRAM_DATA: Record<string, ProgramData> = {
  aa: {
    slug: 'aa',
    name: 'AA',
    fullName: 'Alcoholics Anonymous',
    description: 'A fellowship of men and women who share their experience, strength, and hope with each other that they may solve their common problem and help others to recover from alcoholism.',
    overview: 'AA is a fellowship for people seeking recovery from alcoholism. The program is based on the 12 Steps and 12 Traditions, offering a spiritual approach to recovery that has helped millions of people worldwide.',
    officialWebsite: 'https://www.aa.org/',
    officialAssessment: 'https://www.aa.org/pages/en_US/is-aa-for-you',
    newcomerPage: 'https://www.aa.org/pages/en_US/new-to-aa',
    meetingFinder: 'https://www.aa.org/pages/en_US/find-aa-meetings',
    meetingFinderText: 'Find AA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in AA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  saa: {
    slug: 'saa',
    name: 'SAA',
    fullName: 'Sex Addicts Anonymous',
    description: 'A fellowship of men and women who share their experience, strength, and hope with each other that they may solve their common problem and help others to recover from sexual addiction.',
    overview: 'SAA is a fellowship for people seeking recovery from sexual addiction — compulsive sexual behaviors that feel out of control and cause harm. The program offers a structured approach to recovery through the 12 Steps.',
    officialWebsite: 'https://saa-recovery.org/',
    officialAssessment: 'https://saa-recovery.org/am-i-a-sex-addict/',
    newcomerPage: 'https://saa-recovery.org/newcomers/',
    meetingFinder: 'https://saa-recovery.org/meetings/',
    meetingFinderText: 'Find SAA meetings near you',
    recoveryCommonsTools: [
      'Work the 12 Steps (SAA)',
      'Step 4 Inventory Tools',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  na: {
    slug: 'na',
    name: 'NA',
    fullName: 'Narcotics Anonymous',
    description: 'A fellowship of men and women for whom drugs had become a major problem. We are recovering addicts who meet regularly to help each other stay clean.',
    overview: 'NA is a fellowship for people seeking recovery from drug addiction. The program focuses on the disease of addiction rather than any particular drug, offering support through the 12 Steps.',
    officialWebsite: 'https://na.org/',
    officialAssessment: 'https://na.org/am-i-an-addict/',
    newcomerPage: 'https://na.org/newcomers/',
    meetingFinder: 'https://na.org/meeting-search/',
    meetingFinderText: 'Find NA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in NA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  oa: {
    slug: 'oa',
    name: 'OA',
    fullName: 'Overeaters Anonymous',
    description: 'A Twelve Step, Twelve Tradition program of men and women who meet to share their experience, strength, and hope with each other that they may solve their common problems and help others to recover from compulsive overeating.',
    overview: 'OA is a fellowship for people seeking recovery from compulsive overeating and other eating disorders. The program addresses the physical, emotional, and spiritual aspects of food addiction.',
    officialWebsite: 'https://oa.org/',
    officialAssessment: 'https://oa.org/newcomers/am-i-a-compulsive-overeater/',
    newcomerPage: 'https://oa.org/newcomers/',
    meetingFinder: 'https://oa.org/find-a-meeting/',
    meetingFinderText: 'Find OA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in OA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  ga: {
    slug: 'ga',
    name: 'GA',
    fullName: 'Gamblers Anonymous',
    description: 'A fellowship of men and women who share their experience, strength, and hope with each other that they may solve their common problem and help others to recover from a gambling problem.',
    overview: 'GA is a fellowship for people seeking recovery from gambling addiction. The program offers support through the 12 Steps to help members stop gambling and rebuild their lives.',
    officialWebsite: 'https://www.gamblersanonymous.org/',
    officialAssessment: 'https://www.gamblersanonymous.org/ga/content/20-questions',
    newcomerPage: 'https://www.gamblersanonymous.org/ga/content/newcomers',
    meetingFinder: 'https://www.gamblersanonymous.org/ga/meetings',
    meetingFinderText: 'Find GA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in GA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  da: {
    slug: 'da',
    name: 'DA',
    fullName: 'Debtors Anonymous',
    description: 'A fellowship of men and women who share their experience, strength, and hope with each other that they may solve their common problem and help others to recover from compulsive debting.',
    overview: 'DA is a fellowship for people seeking recovery from compulsive debting and financial problems. The program helps members develop healthy financial habits through the 12 Steps.',
    officialWebsite: 'https://debtorsanonymous.org/',
    officialAssessment: 'https://debtorsanonymous.org/am-i-a-compulsive-debter/',
    newcomerPage: 'https://debtorsanonymous.org/newcomers/',
    meetingFinder: 'https://debtorsanonymous.org/meetings/',
    meetingFinderText: 'Find DA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in DA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  coda: {
    slug: 'coda',
    name: 'CoDA',
    fullName: 'Co-Dependents Anonymous',
    description: 'A fellowship of men and women whose common purpose is to develop healthy relationships. We gather together to support and share in a safe environment.',
    overview: 'CoDA is a fellowship for people seeking recovery from codependency and unhealthy relationship patterns. The program helps members develop healthy boundaries and self-care through the 12 Steps.',
    officialWebsite: 'https://coda.org/',
    officialAssessment: 'https://coda.org/am-i-codependent/',
    newcomerPage: 'https://coda.org/newcomers/',
    meetingFinder: 'https://coda.org/meetings/',
    meetingFinderText: 'Find CoDA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in CoDA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  },
  
  ca: {
    slug: 'ca',
    name: 'CA',
    fullName: 'Cocaine Anonymous',
    description: 'A fellowship of men and women who share their experience, strength, and hope with each other that they may solve their common problem and help others to recover from their addiction.',
    overview: 'CA is a fellowship for people seeking recovery from cocaine addiction and other stimulant drugs. The program offers support through the 12 Steps to help members achieve and maintain sobriety.',
    officialWebsite: 'https://ca.org/',
    officialAssessment: 'https://ca.org/am-i-an-addict/',
    newcomerPage: 'https://ca.org/newcomers/',
    meetingFinder: 'https://ca.org/meetings/',
    meetingFinderText: 'Find CA meetings near you',
    recoveryCommonsTools: [
      'How the 12 Steps work in CA',
      'Sponsor guidance and support'
    ],
    recoveryCommonsRoute: '/discover'
  }
};

export const getProgramBySlug = (slug: string): ProgramData | undefined => {
  return PROGRAM_DATA[slug];
};

export const getAllPrograms = (): ProgramData[] => {
  return Object.values(PROGRAM_DATA);
};
